import { FC, HTMLAttributes, ReactNode } from "react";
import UserChipItem from "./UserChipItem";

interface Props extends HTMLAttributes<HTMLDivElement> {
	user: StoreUser;
	iconEvent?: () => void;
	icon?: ReactNode;
}

const UserSearchItem: FC<Props> = ({
	user,
	iconEvent,
	icon,
	className,
	...restProps
}) => {
	return (
		<div
			role="listitem"
			aria-label={`user-${user.name}`}
			className={`flex-1 ${className ?? ""}`}
			{...restProps}
		>
			<UserChipItem user={user} iconEvent={iconEvent} icon={icon} />
		</div>
	);
};

export default UserSearchItem;
